import { useTranslation } from '@conekta/cronos/i18n';
import { getXprops } from 'app/helpers/getXprops';
import { truncateString } from 'app/util/strings';
import get from 'lodash.get';
import { useContext } from 'react';
import { DefaultTheme, ThemeContext } from 'styled-components';

import FontColor from '../styled-components/FontColor';
import { ParagraphMethod } from '../styled-components/ParagraphMerchant';

import './CashInformation.scss';

const T_ROOT = 'cashInformation';

const CashInformation = () => {
  const { t } = useTranslation();

  const theme: DefaultTheme = useContext(ThemeContext);
  const { font } = theme.colors;

  const xprops = getXprops();
  const cashTextRequested: string = get(xprops, 'options.paymentMethodInformation.cashText', '');

  return (
    <FontColor className="CashInformation">
      {cashTextRequested ? (
        <ParagraphMethod color={font}>{truncateString(cashTextRequested)}</ParagraphMethod>
      ) : (
        <>
          <ParagraphMethod color={font}>{t(`${T_ROOT}.first`)}</ParagraphMethod>
          <ParagraphMethod color={font}>{t(`${T_ROOT}.second`)}</ParagraphMethod>
          <ParagraphMethod color={font}>{t(`${T_ROOT}.third`)}</ParagraphMethod>
        </>
      )}
    </FontColor>
  );
};

export default CashInformation;
